import React from "react";
import { Box, Container } from "@mui/material";
import {
  setTabSelectionsConnections,
  selectTabSelectionsConnections,
  selectEditConnectionOpen,
  selectEditSchemaOpen,
} from "@/features/connections/integrationSlice";
import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepTab";
import ConnectionGrid from "./ConnectionGrid";
import { useDispatch, useSelector } from "react-redux";
import EditConnectionPopup from "@/components/Integrations/ManageConnection/EditConnection/EditConnectionPopup";
import ConnectionPairGrid from "./ConnectionPairGrid/ConnectionPairGrid";

const ConnectionHome = () => {
  const dispatch = useDispatch();
  const tabValue = useSelector(selectTabSelectionsConnections);
  const editPopupOpen = useSelector(selectEditConnectionOpen);
  const editSchemaPopupOpen = useSelector(selectEditSchemaOpen);
  const setTabValue = (value) => dispatch(setTabSelectionsConnections(value));
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

    // heap.io

    const tabDict = {}

    tabDict[0] = "Summary";
    tabDict[1] = "Manager";

    const tabLabel = tabDict[newValue];

    if (tabLabel !== undefined) {
      window.heap.track(`Connections - Select ${tabLabel} Tab`);
    }
  };

  const connectionProps =
    tabValue == 0
      ? {
          displayType: "summary",
          searchText: "Search by Connection or Endpoint",
          title: "Monitor Connections",
          canSelect: false,
          columnVisibilityModel: {
            SchemaCollectionName: false,
            threeDotMenu: false,
          },
        }
      : {
          displayType: "manager",
          searchText: "Search by Connection Name, Endpoint, or Schema ID",
          title: "Manage Connections",
          canSelect: true,
          hasGridActions: true,
          columnVisibilityModel: {
            TotalAttempts: false,
          },
        };

  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "40px",
          width: "100%",
          backgroundColor: "var(--default-light)",
        }}
      >
        <ShepTabs
          variant="tertiary"
          value={tabValue}
          onChange={handleTabChange}
          aria-label="workflow tabs"
        >
          <ShepTab variant="tertiary" key="1" label={"Summary"} />
          <ShepTab variant="tertiary" key="2" label={"Manager"} />
        </ShepTabs>
      </div>
      <Box>
        {/* renders Connection Grid two times to reset filtering, search, and select */}
        {/* can change this in the future if needed */}
        {tabValue === 0 ? (
          <>
            <ConnectionGrid {...connectionProps} />
            <ConnectionPairGrid />
          </>
        ) : null}
        {tabValue === 1 ? (
          <>
            <ConnectionGrid {...connectionProps} />
          </>
        ) : null}
      </Box>
      {editPopupOpen && <EditConnectionPopup initialTab={0} />}
      {editSchemaPopupOpen && <EditConnectionPopup initialTab={1} />}
    </Container>
  );
};
export default ConnectionHome;
